import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Switch,
  FormControlLabel,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import AddIcon from "@material-ui/icons/Add";

import Select from "../../../../components/basics/SelectErp";
import TextField from "../../../../components/basics/TextFieldErp";
import Slide from "@material-ui/core/Slide";

import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion, Line, Form } from "../styles/TipoServico";
import { TipoServicoContext } from "../contexts/TipoServicoContext";
import Card from "../../../../components/cards/Card";
import IconBtn from "../../../../components/buttons/IconBtn";
import TableDefault from "../../../../components/grid/TableDefault";
import useTipoServicoController from "../controllers/TipoServicoController";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import ModalClassEditRetencao from "./ModalTipoEditRetencao";
import { BallContainer } from "../../../prouser/clientes/styles/Cliente";
import RedBall from "../../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../../assets/imgs/bolinha-verde.png";

const AccordionTipoTributacao = ({ ...props }) => {
  const {
    pis,
    setPis,
    cofins,
    setCofins,
    csll,
    setCsll,
    irrf,
    setIrrf,
    inss,
    setInss,
    iss,
    setIss,
    redBcIss,
    setRedBcIss,
    issRet,
    setIssRet,
    uf,
    setUf,
    city,
    setCity,
    aliqRet,
    setAliqRet,
    reduction,
    setReduction,
    tableWithholdings,
    setTableWithholdings,
    withholdingsErrors,
    verificationPisCofinsCsllMinValue,
    setVerificationPisCofinsCsllMinValue,
    verificationIrffMinValue,
    setVerificationIrffMinValue,
    verificationInssMinValue,
    setVerificationInssMinValue,
    listVerification,
    verificationPisCofinsCsll,
    setVerificationPisCofinsCsll,
    verificationIrff,
    setVerificationIrff,
    verificationInss,
    setVerificationInss,
    listPeriod,
    periodPisCofinsCsll,
    setPeriodPisCofinsCsll,
    periodIrrf,
    setPeriodIrrf,
    periodInss,
    setPeriodIndss,
    errorsSubmit,
    listUf,
    listCities,
    listCitiesByUf,
    setListCitiesByUf,
    withheldPisCofinsCsll,
    setWithhedlPisCofinsCsll,
    withheldIrrf,
    setWithheldIrrf,
    withheldInss,
    setWithheldInss,
    withheldSn,
    setWithheldSn,
    taxationList,
    taxation,
    setTaxation,
  } = useContext(TipoServicoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { addMunicipalWithholdings, confirmDeleteItem } =
    useTipoServicoController();

  const [openEditWithholding, setOpenEditWithholding] = useState(false);
  const [indexEditWithholding, setIndexEditWithholding] = useState(null);

  const editWidthholding = (index) => {
    setIndexEditWithholding(index);
    setOpenEditWithholding(true);
  };

  const columnsWithholdings = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  editWidthholding(value.index);
                }}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Deletar">
              <IconButton
                onClick={() =>
                  confirmDeleteItem(
                    value.index,
                    tableWithholdings,
                    setTableWithholdings
                  )
                }
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "center",
      style: { minWidth: 125 },
    },
    {
      label: "Estado",
      id: "tEstado",
      align: "center",
    },
    {
      label: "Município",
      id: "tMunicipio",
      align: "center",
    },
    {
      label: "Alíquota de Retenção (%)",
      id: "tAliquotaRetencao",
      align: "center",
    },
    {
      label: "Redução (%)",
      id: "tReducao",
      align: "center",
    },
    {
      label: "Taxação",
      id: "tTaxacao",
      align: "center",
      format: (value) =>
        taxationList.find(
          (taxation) => taxation.value.toString() === value.tTaxacao.toString()
        ).description,
    },
    {
      label: "Retém p/ SN",
      id: "tRetemSn",
      align: "center",
      format: (value) =>
        value.tRetemSn ? (
          <BallContainer>
            <img src={GreenBall} alt="Ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    if (!Array.isArray(listCities) || !Array.isArray(listUf)) return;

    setUf(
      listUf.find((uf) => uf.id.toString() === queryParams.id_estado) || null
    );

    setCity(
      listCities.find(
        (city) => city.codigo.toString() === queryParams.municipio_codigo
      ) || null
    );
  }, [
    listCities,
    listUf,
    queryParams.id_estado,
    queryParams.municipio_codigo,
    setUf,
    setCity,
    setListCitiesByUf,
  ]);

  useEffect(() => {
    if (!uf) return;

    const newList = listCities.filter(
      (city) => city.estado_codigo === uf.codibge.toString()
    );

    setListCitiesByUf(newList);
  }, [listCities, uf, setListCitiesByUf]);

  useEffect(() => {
    if (!city) return;

    if (
      !listCitiesByUf.find((item) => city.estado_codigo === item.estado_codigo)
    )
      setCity(null);
  }, [listCitiesByUf, city, setCity]);

  return (
    <>
      {openEditWithholding && (
        <ModalClassEditRetencao
          open={openEditWithholding}
          setOpen={setOpenEditWithholding}
          index={indexEditWithholding}
        />
      )}
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip label="TRIBUTAÇÃO" />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded={false}
      >
        <Card padding="10">
          <Grid container>
            <Chip title label="Retenções Federais" bgcolor="secondary" />
          </Grid>
          <Form>
            <Line container spacing={2}>
              <Grid item xs={1}>
                <TextField
                  label="PIS (%)"
                  value={pis}
                  setValue={setPis}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs={1}>
                <TextField
                  label="COFINS (%)"
                  value={cofins}
                  setValue={setCofins}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs={1}>
                <TextField
                  label="CSLL (%)"
                  value={csll}
                  setValue={setCsll}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Vlr. Min. p/ recolhimento"
                  value={verificationPisCofinsCsllMinValue}
                  setValue={setVerificationPisCofinsCsllMinValue}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs>
                <Select
                  value={verificationPisCofinsCsll}
                  setValue={setVerificationPisCofinsCsll}
                  optionsList={listVerification}
                  variant="filled"
                  descriptionField="label"
                  label="Apurar Valores *"
                  error={errorsSubmit.verificationPisCofinsCsll}
                  helperText={errorsSubmit.verificationPisCofinsCsll || ""}
                />
              </Grid>
              <Grid item>
                <Select
                  value={periodPisCofinsCsll}
                  setValue={setPeriodPisCofinsCsll}
                  optionsList={listPeriod}
                  variant="filled"
                  descriptionField="label"
                  label="Período *"
                  error={errorsSubmit.periodPisCofinsCsll}
                  helperText={errorsSubmit.periodPisCofinsCsll || ""}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  label="Retém p/ SN"
                  labelPlacement="top"
                  control={
                    <Switch
                      checked={withheldPisCofinsCsll}
                      onChange={() => {
                        setWithhedlPisCofinsCsll((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Line>
            <Line container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  label="IRRF (%)"
                  value={irrf}
                  setValue={setIrrf}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Vlr. Min. p/ recolhimento"
                  value={verificationIrffMinValue}
                  setValue={setVerificationIrffMinValue}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs>
                <Select
                  value={verificationIrff}
                  setValue={setVerificationIrff}
                  optionsList={listVerification}
                  variant="filled"
                  descriptionField="label"
                  label="Apurar Valores *"
                  error={errorsSubmit.verificationIrff}
                  helperText={errorsSubmit.verificationIrff || ""}
                />
              </Grid>
              <Grid item>
                <Select
                  value={periodIrrf}
                  setValue={setPeriodIrrf}
                  optionsList={listPeriod}
                  variant="filled"
                  descriptionField="label"
                  label="Período *"
                  error={errorsSubmit.periodIrrf}
                  helperText={errorsSubmit.periodIrrf || ""}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  label="Retém p/ SN"
                  labelPlacement="top"
                  control={
                    <Switch
                      checked={withheldIrrf}
                      onChange={() => {
                        setWithheldIrrf((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Line>
            <Line container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  label="INSS (%)"
                  value={inss}
                  setValue={setInss}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  label="Vlr. Min. p/ recolhimento"
                  value={verificationInssMinValue}
                  setValue={setVerificationInssMinValue}
                  mask="decimal"
                />
              </Grid>
              <Grid item xs>
                <Select
                  value={verificationInss}
                  setValue={setVerificationInss}
                  optionsList={listVerification}
                  variant="filled"
                  descriptionField="label"
                  label="Apurar Valores *"
                  error={errorsSubmit.verificationInss}
                  helperText={errorsSubmit.verificationInss || ""}
                />
              </Grid>
              <Grid item>
                <Select
                  value={periodInss}
                  setValue={setPeriodIndss}
                  optionsList={listPeriod}
                  variant="filled"
                  descriptionField="label"
                  label="Período *"
                  error={errorsSubmit.periodInss}
                  helperText={errorsSubmit.periodInss || ""}
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  label="Retém p/ SN"
                  labelPlacement="top"
                  control={
                    <Switch
                      checked={withheldInss}
                      onChange={() => {
                        setWithheldInss((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Line>
          </Form>
        </Card>
        <Line />
        <Line />
        <Card padding="10">
          <Grid container>
            <Chip title label="Retenções Municipais" bgcolor="secondary" />
          </Grid>
          <Form>
            <Line />
            <Line container spacing={2}>
              <Grid item xs>
                <TextField
                  label="ISS (%)"
                  value={iss}
                  setValue={setIss}
                  mask="decimal"
                  decimals={5}
                />
              </Grid>
              <Grid item xs>
                <TextField
                  label="Redução da Base de Calculo ISS (%)"
                  value={redBcIss}
                  setValue={setRedBcIss}
                  mask="decimal"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  label="ISS Retido"
                  labelPlacement="top"
                  control={
                    <Switch
                      checked={issRet}
                      onChange={() => {
                        setIssRet((current) => !current);
                      }}
                      color="primary"
                    />
                  }
                />
              </Grid>
            </Line>
            <Line />
            <Line />
            <Slide direction="up" in={issRet} mountOnEnter unmountOnExit>
              <Grid item xs>
                <Card line="left" lineColor="primary" fullWidth>
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Select
                        value={uf}
                        setValue={setUf}
                        optionsList={listUf}
                        descriptionField="estado"
                        label="UF"
                        error={withholdingsErrors.uf}
                        helperText={withholdingsErrors.uf || ""}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Select
                        value={city}
                        setValue={setCity}
                        optionsList={listCitiesByUf}
                        descriptionField="municipio"
                        label="Município"
                        error={withholdingsErrors.city}
                        helperText={withholdingsErrors.city || ""}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Select
                        value={taxation}
                        setValue={setTaxation}
                        optionsList={taxationList}
                        descriptionField="description"
                        label="Taxação"
                        error={withholdingsErrors.taxation}
                        helperText={withholdingsErrors.taxation || ""}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Alíquota de Retenção (%)"
                        value={aliqRet}
                        setValue={setAliqRet}
                        error={withholdingsErrors.aliqRet}
                        helperText={withholdingsErrors.aliqRet || ""}
                        mask="decimal"
                        decimals={5}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        label="Redução (%)"
                        value={reduction}
                        setValue={setReduction}
                        error={withholdingsErrors.reduction}
                        helperText={withholdingsErrors.reduction || ""}
                        mask="decimal"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <FormControlLabel
                        label="Retém p/ SN"
                        labelPlacement="top"
                        control={
                          <Switch
                            checked={withheldSn}
                            onChange={() => {
                              setWithheldSn((current) => !current);
                            }}
                            color="primary"
                          />
                        }
                      />
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={1}>
                      <Tooltip title="Adicionar">
                        <span>
                          <IconBtn onClick={addMunicipalWithholdings}>
                            <AddIcon />
                          </IconBtn>
                        </span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Card>
                <Line container />
                <Line container justifyContent="center">
                  <TableDefault
                    tableTitle=""
                    values={tableWithholdings}
                    columns={columnsWithholdings}
                  />
                </Line>
              </Grid>
            </Slide>
          </Form>
        </Card>
      </Fieldset>
    </>
  );
};

export default AccordionTipoTributacao;
